import { CSSObject, Drawer as MuiDrawer, DrawerProps, styled, Theme } from '@mui/material';
//@ts-ignore
import React from 'react';
import ThemeConfig from 'src/theme';

const transition = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create(['width', 'border-radius'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    '& .MuiDrawer-paper': {
      height: 'auto',
      top: '20%',
      right: '10px',
      maxHeight: '80vh',
      color: '#fff',
      border: 'none',
      background: 'rgba(0, 0, 0, 0.3)',
      borderRadius: '15px',
      backdropFilter: 'blur(15px)',
      overflowX: 'hidden',
      width: open ? '150px' : '35px',

      ...(open && {
        ...transition(theme),
      }),
      ...(!open && {
        ...transition(theme),
      }),
    },
  }),
);

export const SidebarDrawer: React.FC<DrawerProps & { children?: any }> = ({
  children,
  ...rest
}) => {
  return (
    <ThemeConfig>
      <Drawer {...rest}>{children}</Drawer>
    </ThemeConfig>
  );
};
